import React from "react";

const PlusIcon = ({
  onClickFn = () => {},
  fill = "white",
  height = "14px",
  width = "14px",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.99998 3.33337V12.6667M3.33331 8.00004H12.6666"
        stroke="white"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default PlusIcon;
